import React from "react"
import { EventKind, Notification } from "@nova/schemas"
import {
    buildCopy,
    CopyRegistry,
    isMentionNotification,
    NotificationContext,
} from "@nova/notifications"
import { CommentText } from "plugins/Toolbox/MapComments/CommentText"

export type WebNotificationCopy = {
    title: string
    subtitle?: string
    body?: React.ReactNode
}

const webCopyRegistry: CopyRegistry<WebNotificationCopy> = {
    [EventKind.LayerProcessed]: (text) => ({
        title: `${text.layerTypeLabel} job finished processing`,
        subtitle: text.projectName,
    }),
    [EventKind.LayerProcessingFailed]: (text) => ({
        title: `${text.layerTypeLabel} Failed`,
        subtitle: text.projectName,
    }),
    [EventKind.StreamStarted]: (text) => ({
        title: text.actorName,
        subtitle: `Started a live stream - ${text.projectName}`,
    }),
    [EventKind.LocationSharingStarted]: (text) => ({
        title: text.actorName,
        subtitle: `Started sharing their location - ${text.projectName}`,
    }),
    [EventKind.LocationSharingEnded]: (text) => ({
        title: text.actorName,
        subtitle: `Stopped sharing their location - ${text.projectName}`,
    }),
    [EventKind.StreamShared]: (text) => ({
        title: text.actorName,
        subtitle: `Shared a live stream with you - ${text.projectName}`,
    }),
    [EventKind.MissionGroupStreamShared]: (text) => ({
        title: text.actorName,
        subtitle: "Shared a live stream with you",
    }),
    [EventKind.MissionGroupDashboardShared]: (text) => ({
        title: text.actorName,
        subtitle: "Shared a mission group dashboard with you",
    }),
    [EventKind.AccessRequested]: (text) => ({
        title: text.actorName,
        subtitle: `Has requested access to ${text.accessResourceName}`,
    }),
    [EventKind.AccessGranted]: (text) => ({
        title: `${text.entityType} Access Approved`.trim(),
        subtitle: `You can now access ${text.accessResourceName}`,
    }),
    [EventKind.CommentCreated]: (text, notification) => ({
        title: text.actorName,
        subtitle: isMentionNotification(notification)
            ? `Mentioned you in ${text.projectName}`
            : `Replied in a thread in ${text.projectName}`,
        body: <CommentText text={text.commentSnippet} />,
    }),
}

export const buildWebCopy = (notification: Notification, context: NotificationContext) =>
    buildCopy(webCopyRegistry, notification, context)
